import { Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { AppText } from '@/components/ui/app-text';
import { colors, radius, spacing } from '@/theme/tokens';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '0', 'DEL'] as const;

/** Numeric keypad — the expense entry must take 2-3 taps and <5 s */
export function AmountKeypad({ onKey }: { onKey: (key: string) => void }) {
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: spacing.xs }}>
      {KEYS.map((key) => (
        <Pressable
          key={key}
          accessibilityRole="button"
          onPress={() => onKey(key)}
          style={({ pressed }) => ({
            width: '31%',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: pressed ? colors.primaryTile : colors.surface,
            borderRadius: radius.button,
            minHeight: 56,
          })}
        >
          {key === 'DEL' ? (
            <Ionicons name="backspace-outline" size={22} color={colors.primary} />
          ) : (
            <AppText variant="headlineSm" color={colors.textPrimary}>
              {key}
            </AppText>
          )}
        </Pressable>
      ))}
    </View>
  );
}
